const A1_Raw_Material_Acquisition = "A1: Raw Material Acquisition";
const A2_Transport_to_Factory = "A2: Transport to Factory";
const A3_Manufacturing = "A3: Manufacturing";
const A4_Transport_to_Site = "A4: Transport to Site";
const A5_Construction_Installation = "A5: Construction-Installation";

const B1_Use = "B1: Use";
const B2_Maintenance = "B2: Maintenance";
const B3_Repair = "B3: Repair";
const B4_Replacement = "B4: Replacement";
const B5_Refurbishment = "B5: Refurbishment";
const B6_Operational_Energy_Use = "B6: Operational energy use";
const B7_Operational_Water_Use = "B7: Operational water use";

const C1_Deconstruction_Demolition = "C1: Deconstruction / Demolition";
const C2_Transport_to_Waste_Disposal = "C2: Transport to Waste / Disposal";
const C3_Waste_Processing = "C3: Waste Processing";
const C4_Disposal_of_Waste = "C4: Disposal of Waste";

const D_Reuse_Recovery_Recycling_Potential = "D: Reuse-Recovery-Recycling Potential";

export const LCA_stages_A1_A3 = [A1_Raw_Material_Acquisition, A2_Transport_to_Factory, A3_Manufacturing];
export const LCA_stages_A1_A5 = [...LCA_stages_A1_A3, A4_Transport_to_Site, A5_Construction_Installation];
export const LCA_stages_B1_B5 = [B1_Use, B2_Maintenance, B3_Repair, B4_Replacement, B5_Refurbishment];
export const LCA_stages_B1_B7 = [...LCA_stages_B1_B5, B6_Operational_Energy_Use, B7_Operational_Water_Use];
export const LCA_stages_C1_C4 = [C1_Deconstruction_Demolition, C2_Transport_to_Waste_Disposal, C3_Waste_Processing, C4_Disposal_of_Waste];
export const LCA_stages_D = [D_Reuse_Recovery_Recycling_Potential];
